<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" class="mat-elevation-z8 logo-card-page" [ngStyle]="style">
    <ng-content></ng-content>
</mat-card>